module.exports = __webpack_public_path__ + "img/1.99206314.jpg";